/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductSelector_viewer = {
    readonly country: {
        readonly productCategories: ReadonlyArray<{
            readonly products: ReadonlyArray<{
                readonly isComingSoon: boolean;
                readonly code: string;
                readonly name: string;
                readonly shortName: string;
                readonly path: string | null;
            }>;
        }>;
    } | null;
    readonly " $refType": "ProductSelector_viewer";
};
export type ProductSelector_viewer$data = ProductSelector_viewer;
export type ProductSelector_viewer$key = {
    readonly " $data"?: ProductSelector_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductSelector_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProductSelector_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "country",
      "type": "String!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "country",
      "name": "countryByCode",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "code",
          "variableName": "country"
        }
      ],
      "concreteType": "Country",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "productCategories",
          "name": "websiteMarketingProductCategories",
          "storageKey": null,
          "args": null,
          "concreteType": "WebsiteMarketingProductCategory",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "products",
              "storageKey": null,
              "args": null,
              "concreteType": "WebsiteMarketingProduct",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isComingSoon",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "code",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "shortName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "path",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '44be3173a355d280a3365eb26ef0597b';
export default node;
